<template>
    <div>
        <form class="needs-validation" novalidate>
            <!-- ***** start custom content ***** -->

            <h1>{{$t('title')}}</h1>
            <p class="lead">{{$t( 'comment' ) }}</p>
            <div class="callout callout-warning">
                <p>{{$t( 'side_note_1') }}</p>
            </div>
            <fieldset>
                <legend>{{ $t( 'personal_information' ) }}</legend>
                <div class="form-row">
                    <div class="col-md-5 mb-3">
                        <label for="firstName">{{ $t( 'first_name' ) }}</label>
                        <input id="firstName" v-model="first_name" type="text" class="form-control" required>
                        <div class="invalid-feedback">
                            {{$t('valid_first')}}
                        </div>
                    </div>
                    <div class="col-md-5 mb-3">
                        <label for="lastName">{{ $t( 'last_name' ) }}</label>
                        <input id="lastName" v-model="last_name" type="text" class="form-control" required>
                        <div class="invalid-feedback">{{$t('valid_last')}}</div>
                    </div>
                </div>
                <h2 class="h6 mt-3">{{ $t( 'date_of_birth' ) }}</h2>
                <p>{{$t( 'eligibigle_to_vote_note' )}}</p>
                <div class="form-row">
                    <div class="col-7 col-md-3 mb-3">
                        <label for="monthOfBirth">{{ $t( 'month' ) }}</label>
                        <select id="monthOfBirth" v-model="birth_month" class="custom-select" required>
                            <option value="01">{{$t('january')}}</option>
                            <option value="02">{{$t('february')}}</option>
                            <option value="03">{{$t('march')}}</option>
                            <option value="04">{{$t('april')}}</option>
                            <option value="05">{{$t('may')}}</option>
                            <option value="06">{{$t('june')}}</option>
                            <option value="07">{{$t('july')}}</option>
                            <option value="08">{{$t('august')}}</option>
                            <option value="09">{{$t('september')}}</option>
                            <option value="10">{{$t('october')}}</option>
                            <option value="11">{{$t('november')}}</option>
                            <option value="12">{{$t('december')}}</option>
                        </select>
                        <div class="invalid-feedback">{{$t('valid_month')}}</div>
                    </div>
                    <div class="col-12 col-md-9">
                        <div class="form-row">
                            <div class="col-sm-2 col-2 mb-3">
                                <label for="dayOfBirth">
                                    {{$t( 'day' )}}
                                </label>
                                <input type="text" id="dayOfBirth" v-model="birth_day" class="form-control" required>
                                <small class="form-text text-muted">
                                    {{$t('dd')}}
                                </small>
                                <div class="invalid-feedback">{{$t('valid_day')}}</div>
                            </div>
                            <div class="col-sm-3 col-3 mb-3">
                                <label for="yearOfBirth">{{ $t( 'year' ) }}</label>
                                <input type="text" id="yearOfBirth" v-model="birth_year" class="form-control" required>
                                <small class="form-text text-muted">
                                    {{$t('yyyy')}}
                                </small>
                                <div class="invalid-feedback">{{$t('valid_year')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6 mb-3">
                        <label for="address">{{ $t( 'select_address' ) }}</label>
                        <!--<vue-simple-suggest id="addressSearch" :debounce="0" v-model="address" autocomplete="off" display-attribute="address" value-attribute="linkid" :list="getAddressList" v-on:select="selectAddress" @change="address_changing"></vue-simple-suggest>-->
                        <vue-simple-suggest id="addressSearch" :debounce="500" v-model="address" autocomplete="off" display-attribute="value" value-attribute="id" :list="getAddressList" v-on:select="selectAddress" @change="address_changing"></vue-simple-suggest>
                        <small class="form-text text-muted">
                            ({{$t('address_note')}})
                        </small>
                    </div>
                </div>
            </fieldset>

            <div class="row no-gutters mb-5">
                <div class="col"><button type="button" class="btn btn-primary mt-2" @click="voter_search">{{$t('search')}}</button></div>
            </div>

            <!-- START on voter list -->

            <div v-if="found_response">
                <div class="alert alert-success" role="alert">
                    {{$t('comment_10')}}
                </div>
                <p>
                    <span class="font-weight-bold">{{$t('first_name')}}{{ $t('colon') }}</span> {{ first_name }}<br>
                    <span class="font-weight-bold">{{$t('last_name')}}{{ $t('colon') }}</span> {{ last_name }}<br>
                    <span class="font-weight-bold">{{$t('address')}}{{ $t('colon') }}</span> {{ address }}
                </p>
                <br clear="all">
                <div class="row no-gutters" v-if="!registry_closed">
                    <div class="col" v-if="page_type != 'seb'">
                        <p>{{$t('comment_11')}}</p>
                        <button class="btn btn-secondary mt-2" type="button" @click="change_address">{{$t('update_your_information')}}</button>
                    </div>
                    <div class="col" v-if="page_type == 'seb'">
                        <button class="btn btn-secondary mt-5" type="button" @click="sealed_envelope_ballot_click">{{$t('sealed_envelope_ballot')}}</button>
                    </div>
                </div>
            </div>
            <!-- END on voter list -->
            <!-- START not on voter list -->

            <div v-if="register">
                <div class="alert alert-danger" role="alert">{{$t( 'comment_1' ) }}</div>
                <p class="font-weight-bold">{{$t( 'comment_2' ) }}</p>

                <p>
                    <span class="font-weight-bold">{{$t( 'first_name' ) }}{{ $t('colon') }}</span> {{ first_name }}<br>
                    <span class="font-weight-bold">{{$t( 'last_name' ) }}{{ $t('colon') }}</span> {{ last_name }}<br>
                    <span class="font-weight-bold">{{$t( 'date_of_birth' ) }}{{ $t('colon') }}</span> {{ birth_date }}<br>
                    <span class="font-weight-bold">{{$t( 'address' ) }}{{ $t('colon') }}</span> {{ address }}
                </p>

                <p class="small">{{$t( 'comment_3' ) }}</p>


                <div v-if="!registry_closed">

                    <aside>
                        <div class="callout callout-info">
                            <h2 class="h6">{{$t('comment_4') }}</h2>
                            <ul>
                                <li>{{$t('comment_5')}}</li>
                                <li>{{$t('comment_6')}}</li>
                                <li>{{$t('comment_7')}}</li>
                            </ul>
                        </div>
                    </aside>
                    <p>{{$t('comment_9')}} <a class="link" @click="register_voter">{{ $t('or_submit_update') }}</a></p>

                    <div class="row no-gutters">
                        <div class="col"><button class="btn btn-primary mt-2" @click="register_voter">{{$t('register_to_vote')}}</button></div>
                    </div>
                </div>
                <div v-if="registry_closed">

                    <aside>
                        <div class="callout callout-info">
                            <h2 class="h6">{{$t('comment_4') }}</h2>
                            <ul>
                                <li>{{$t('comment_5')}}</li>
                                <li>{{$t('comment_6')}}</li>
                                <li>{{$t('comment_7')}}</li>
                            </ul>
                        </div>
                    </aside>
                    <p>{{$t('comment_15')}}</p>
                    <p>{{$t('comment_16')}}</p>
                </div>
            </div>
            <!-- END not on voter list -->
        </form>
        <p class="font-italic">{{$t('privacy')}}</p>
    </div>

</template>

<script>
    import VueSimpleSuggest from "vue-simple-suggest";
    import "vue-simple-suggest/dist/styles.css";
    import axios from 'axios';

    var now = new Date();
    now = new Date(now.getTime() - (1 * 60 * 60 * 1000 * 6));
    // var end_date = new Date('2018-08-27T16:00:00');
    var end_date = new Date('2022-08-31T16:30:00');
    end_date = new Date(end_date.getTime() - (1 * 60 * 60 * 1000 * 6));
    
    var REGISTRY_CLOSED = (now > end_date);

    export default {
        name: 'VoterApp',
        props: ['page_type'],
        components: {
            VueSimpleSuggest,
        },
        data() {
            return {
                searchData: "",
                searchFound: false,
                searchClick: false,
                data: {},
                errors: [],
                first_name: null,
                last_name: null,
                birth_month: "01",
                birth_day: null,
                birth_year: null,
                valid_year: true,
                address: null,
                term: '',
                response: {},
                addresses: [],
                fetching: false,
                register: false,
                top_address: {},
                registry_closed: REGISTRY_CLOSED,
                address_id: null,
                url: this.$APP_API_URL
            }
        },
        created: async function () {
            let url = this.url.replace("ElectionApplication.asp", "DateValidation.ashx");
            
            await axios.get(url).then((result) => {
                this.registry_closed = eval(result.data.toLowerCase());
            });
        },

        computed: {
            validate_day: function () {
                return ((this.birth_day !== null) && (parseInt(this.birth_day, 10) > 0 && parseInt(this.birth_day, 10) < 32));
            },
            validate_year: function () {
                //return ((this.birth_year === null) || (this.birth_year > 1900 && this.birth_year < 2002));
                return ((this.birth_year !== null) && this.birth_year > 1900)
            },
            validate_month: function () {
                //return ((this.birth_month === null) || (parseInt(this.birth_month, 10) > 0 && parseInt(this.birth_month, 10) < 13));
                return (this.birth_month !== null);
            },
            validate_first: function () {
                //return ((this.first_name === null) || (this.first_name.length > 0));
                return (this.first_name !== null && this.first_name !== "");
            },
            validate_last: function () {
                return ((this.last_name !== null) && (this.last_name !== ""));
            },
            valid_without_address: function () {
                return (this.validate_day && this.validate_year && this.validate_month && this.validate_first && this.validate_last);
            },
            valid_home: function () {
                return (this.street_number && (this.street_number.length > 0) && this.street_name && (this.street_name.length > 0));
            },
            valid_mailing: function () {
                return (this.mailing_number && (this.mailing_number.length > 0) && this.mailing_name && (this.mailing_name.length > 0));
            },
            valid_address: function () {
                return (this.mailing_same_as_street == "Yes") ? this.valid_home : (this.valid_home && this.valid_mailing);
            },

            valid_form: function () {
                return (this.valid_without_address && this.validate_not_null && this.address_id);
            },
            validate_not_null: function () {
                return !(this.birth_day == null && this.birth_month == null && this.birth_year == null && this.first_name == null && this.last_name == null);
            },
            found_response: function () {
                return (this.response) && (this.response.name) && (this.response.address);
            },
            birth_date: function () {
                return this.birth_year + '-' + ('0' + this.birth_month).slice(-2) + '-' + ('0' + this.birth_day).slice(-2);
            },

            entered_address: function () {
                return (this.address && this.address.value && this.address.value.length > 0) ? this.address.value : this.term;
            },
            allow_register: function () {
                return (this.valid_without_address && this.register && !this.registry_closed);
            },
            voter_id: function () {
                return this.response.id;
            }
        },
        methods: {
            getAddressList(query) {
                let url = this.url + '?action=find-address&term=' + query;
                //let url = 'https://mapapi.winnipeg.ca/mapapi/autocompletelookupjson.ashx?stype=lookup3&q=' + query;

                return fetch(url, { method: 'GET' })
                    .then(response => response.json())
                    .then(json => json);
            },
            selectAddress(result) {
                this.searchClick = true;
                this.address_id = result.id;
                //this.address_id = result.linkid;
            },

            cancel: function () {
                window.location = "PrivacyAndSecurity.stm";
            },
            address_found: function (address) {
                this.address = address;
            },

            address_changing: function (address) {
                this.address = {},
                    this.term = address;
            },

            sealed_envelope_ballot_click: function () {
                //window.location = "sealed-envelope-ballot-step-2/" + this.voter_id;

                this.save_address();

                this.$router.push({ name: "SealedEnvelopeBallotStep1", params: { page_type: 'seb', voter_id: this.voter_id } });
            },

            voter_search: function () {
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = false;

                Array.prototype.filter.call(forms, function (form) {
                    validation = form.checkValidity();

                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');
                });

                if (validation === true) {
                    (function (that) {

                        var data = {
                            firstName: that.first_name,
                            lastName: that.last_name,
                            birthDate: that.birth_date,
                            addressId: that.address_id,
                            action: 'voter-lookup'
                        };
                        axios.get(that.url, { params: data })
                            .then(function (response) {
                                if (response && response.data) {
                                    that.response = response.data;
                                    that.register = false;
                                } else {
                                    that.register = true;
                                    that.response = {};
                                }
                            })
                            .catch(function (error) {
                                that.errors.push(error);
                            })
                    })(this);
                }
            },
            fake_search: function () {
                this.register = true;
            },
            register_voter: function () {

                this.save_address();

                this.$router.push({ name: "Step1", params: { page_type: this.page_type, voter_id: 0 } });
            },

            save_address: function () {
                var voter = {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    birth_month: this.birth_month,
                    birth_year: this.birth_year,
                    birth_day: this.birth_day,
                    voter_id: this.voter_id,
                    address: this.address
                };

                this.$store.dispatch("SAVE_PERSONAL_INFO", voter);

            },

            change_address: function () {
                this.save_address();

                this.$router.push({ name: "Step2", params: {page_type: this.page_type, voter_id: this.voter_id} });
            },
        },

        watch: {
            birth_day: function () {
                this.response = {};
                this.register = false;
                this.errors = [];
            },
            birth_month: function () {
                this.response = {};
                this.register = false;
                this.errors = [];
            },
            birth_year: function () {
                this.response = {};
                this.register = false;
                this.errors = [];
            },
            first_name: function () {
                this.response = {};
                this.register = false;
                this.errors = [];
            },
            last_name: function () {
                this.response = {};
                this.register = false;
                this.errors = [];
            },
            term: function () {
                this.response = {};
                this.register = false;
                this.errors = [];
            },

        },

        mounted: function () {

        }
    }
</script>
